import { useCallback, useEffect } from "react";
import { IFrameEvents } from "../constants/enum/iframe";
import useIFrameEvent from "./useIFrameEvent";
import { useAppSelector } from "../app/hooks";
import { useWalletContext } from "@/wallet/WalletProvider";

const useWallet = (iframeRef?: React.RefObject<HTMLIFrameElement>) => {
  const { wallet, connectWallet, disconnectWallet } = useWalletContext();
  const { signMsg, signature } = useAppSelector((state) => state.auth);

  const account = wallet ? wallet.accounts[0].address : "";

  const postMessageToIframe = useCallback(
    (data: { eventType: IFrameEvents; eventData: any }) => {
      if (iframeRef?.current?.contentWindow) {
        iframeRef.current.contentWindow.postMessage(data, "*");
      }
    },
    [iframeRef]
  );

  const handleIFrameEvent = useCallback(
    (eventName: IFrameEvents) => {
      if (iframeRef && eventName === IFrameEvents.PAGE_READY) {
        postMessageToIframe({
          eventData: account,
          eventType: IFrameEvents.ACCOUNT_CHANGE,
        });

        postMessageToIframe({
          eventData: {
            signMsg,
            signature,
          },
          eventType: IFrameEvents.AUTH_SIGNED,
        });
      }
    },
    [account, iframeRef, postMessageToIframe, signMsg, signature]
  );

  useIFrameEvent(iframeRef, handleIFrameEvent);

  useEffect(() => {
    postMessageToIframe({
      eventData: account,
      eventType: IFrameEvents.ACCOUNT_CHANGE,
    });
  }, [account, postMessageToIframe]);

  useEffect(() => {
    postMessageToIframe({
      eventData: {
        signMsg,
        signature,
      },
      eventType: IFrameEvents.AUTH_SIGNED,
    });
  }, [postMessageToIframe, signMsg, signature]);

  return {
    wallet,
    connectWallet,
    disconnectWallet,
    account,
    isConnected: wallet ? true : false,
  };
};

export default useWallet;
